import React from "react";
import styled from "styled-components";
import { inputStyles } from "./InputStyles";
import { Theme } from "../../themes/theme";

const Wrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 6px;

  label {
    text-transform: uppercase;
    font-size: ${Theme.font.fontSize.xs};
    font-weight: ${Theme.font.fontWeight.medium};
    letter-spacing: ${Theme.font.letterSpacing.widest};
    color: ${Theme.color.text.secondary};
  }
  span {
    color: ${Theme.color.text.primary};
    font-size: 12px;
  }
`;

const Input = styled.select`
  ${inputStyles}
  appearance: none;
  cursor: pointer;
  color: ${Theme.color.text.secondary};
`;

function PrimaryDropdown({ label, error, ...props }) {
  return (
    <Wrapper>
      <label>{label}</label>

      <Input {...props} />

      {error && <span>{error}</span>}
    </Wrapper>
  );
}

export default PrimaryDropdown;
